const SETEMPREENDIMENTOS = (state, list) => {
  state.empreendimentos = list
}

export default {
  SETEMPREENDIMENTOS
}
